/**
 * Banner que muestra el cupón de lanzamiento cuando REACT_APP_SHOW_LAUNCH_COUPON=true.
 * Usar junto a cualquier UI de compra de la suscripción (49,99€).
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { LAUNCH_COUPON } from "../config/launchCoupon";

export function LaunchCouponBanner({ compact = false, sx = {} }) {
	if (!LAUNCH_COUPON.show) return null;

	return (
		<Box
			sx={{
				mb: compact ? 1.5 : 2,
				p: compact ? 1 : 1.5,
				borderRadius: "12px",
				bgcolor: "rgba(16, 185, 129, 0.1)",
				border: "1px solid rgba(16, 185, 129, 0.35)",
				...sx,
			}}
		>
			<Typography
				variant="body2"
				sx={{
					fontSize: compact ? "0.8125rem" : "0.875rem",
					color: "#047857",
					fontWeight: 600,
					lineHeight: 1.4,
				}}
			>
				Por tiempo limitado: usa el cupón{" "}
				<Box
					component="span"
					sx={{
						display: "inline-block",
						px: 0.75,
						py: 0.25,
						borderRadius: "6px",
						bgcolor: "rgba(16, 185, 129, 0.2)",
						fontFamily: "monospace",
						fontWeight: 700,
					}}
				>
					{LAUNCH_COUPON.code}
				</Box>{" "}
				al pagar y se descontarán {LAUNCH_COUPON.discountEur}€ del total (suscripción a{" "}
				{LAUNCH_COUPON.priceAfterDiscount.toFixed(2).replace(".", ",")}€/año).
			</Typography>
		</Box>
	);
}
